export const iconFontAwesomeEmojiFaceGrimace = (
	<i className="fa-solid fa-face-grimace"></i>
);
